import React, { useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory, Link } from 'react-router-dom';

import Notification from 'components/Notification';
import { ReactComponent as JavelinLogo } from 'assets/icons/logo-javelin.svg';
import PATHS from 'routes/paths';
import { getMe } from 'redux/slices/auth';

const AuthBackground = ({
  header1,
  header2,
  footer,
  children,
  onClick,
  canDisplayFlash,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { authenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (authenticated) {
      history.replace(PATHS.home);
    }
  }, [authenticated, history]);

  return (
    <div className="h-auto md:py-20 min-h-screen w-screen bg-map bg-no-repeat bg-fixed bg-cover bg-bottom">
      <div className="card border-none px-0 py-0 mx-auto w-screen md:w-144 rounded-md min-h-screen md:min-h-full">
        {canDisplayFlash && (
          <Notification className="mx-auto w-11/12 md:w-6/12 fixed top-4" />
        )}
        <div className="w-full overflow-hidden rounded-none border-0 px-5 md:px-14 mb-12 mt-14">
          <JavelinLogo className="h-5 w-auto block self-start" />
          <h1 className="text-2xl md:text-3xl font-semibold mt-12 text-left text-javelin-gray-dark">
            {header1}
          </h1>
          <h2 className="text-sm md:text-base mt-3 mb-12 text-left text-javelin-gray-light">
            {header2}
          </h2>
          {children}
        </div>
        {footer && (
          <div className="m-5 p-5 md:m-0 md:p-14 rounded md:rounded-t-none md:rounded-b-md bg-javelin-blue-dark bg-opacity-5 md:border-t border-javelin-gray-border text-sm md:text-base">
            <p className="inline mr-2 text-javelin-gray-dark">
              {footer.plainText}
            </p>
            {!!footer.to && (
              <Link
                data-testid="link"
                to={footer.to}
                className="text-javelin-blue-dark font-bold border-0 focus:outline-none"
              >
                {footer.linkText}
              </Link>
            )}
            {!!onClick && (
              <button
                data-testid="button"
                onClick={onClick}
                type="button"
                className="text-javelin-blue-dark font-bold border-0 focus:outline-none text-sm md:text-base text-left"
              >
                {footer.linkText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

AuthBackground.propTypes = {
  header1: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  header2: PropTypes.string,
  children: PropTypes.node,
  footer: PropTypes.shape({
    plainText: PropTypes.string,
    linkText: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  }),
  onClick: PropTypes.func,
  canDisplayFlash: PropTypes.bool,
};
AuthBackground.defaultProps = {
  canDisplayFlash: true,
};
export default memo(AuthBackground);
